"use client";
import "./PointsContainer.scss";
import AnimateHeight from "react-animate-height";
import { useEffect, useId, useRef, useState } from "react";

export default function PointsContainer({
  data,
  color,
  heading,
  background,
  size,
  wrapperClassName = "",
  /** Unique id for aria + AnimateHeight (avoids duplicate "example-panel" on page) */
  panelId: panelIdProp,
  /**
   * Show expand/collapse when list has at least this many items.
   * Default 7 matches old behavior (was `data.length > 6`).
   */
  minItemsForCollapseToggle = 7,
  /** Pixel height when collapsed */
  collapsedHeight = 200,
}) {
  const reactId = useId().replace(/:/g, "");
  const panelId = panelIdProp ?? `points-panel-${reactId}`;

  const [expanded, setExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const pointsContentRef = useRef(null);
  const height = expanded ? "auto" : collapsedHeight;

  const list = Array.isArray(data) ? data : [];
  const meetsItemThreshold = list.length >= minItemsForCollapseToggle;
  const showCollapse = meetsItemThreshold && hasOverflow;

  useEffect(() => {
    const node = pointsContentRef.current;
    if (!node) {
      setHasOverflow(false);
      return;
    }

    // Toggle only when there is hidden content beyond collapsed height.
    setHasOverflow(node.scrollHeight > collapsedHeight);
  }, [collapsedHeight, list.length]);

  return (
    <>
      <div
        className={`pointsWrapper ${wrapperClassName}`.trim()}
        style={{ background: background }}
      >
        <div>{heading}</div>
        <AnimateHeight
          style={{ width: "100%" }}
          id={panelId}
          duration={500}
          height={showCollapse ? height : "auto"}
        >
          <div className="pointsContainer" ref={pointsContentRef}>
            {list.map((item, i) => {
              return (
                <div className="point" key={i}>
                  <div className="count" style={{ backgroundColor: color }}>
                    {i + 1}
                  </div>
                  <div>
                    <p className="pointData">{item}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </AnimateHeight>
        {showCollapse ? (
          <div className="showButtonContainer">
            <button
              type="button"
              className="showMoreCostInIndiaBtn"
              aria-expanded={expanded}
              aria-controls={panelId}
              onClick={() => setExpanded((v) => !v)}
            >
              {expanded ? "View Less" : "Show More +"}
            </button>
          </div>
        ) : null}
      </div>
    </>
  );
}
